import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, withRouter } from 'react-router-dom'
import { Button, Collapse } from 'reactstrap'
import settings from '../../api/settings/hooks'
import AppPermissionsSwitcher from '../../Components/AppPermissionsSwitcher/AppPermissionsSwitcher'
import AppTopSwitcher from '../../Components/AppTopSwitcher/AppTopSwitcher'
import useIsMobile from '../../hooks/useIsMobile'
import { selectIsImpersonated } from '../../store/auth'
import { resetTableCheckbox } from '../../store/table'
import navdata from '../LayoutMenuData'

const LG_BREAKPOINT = 992

const HorizontalLayout = () => {
    const dispatch = useDispatch()
    const [isMoreMenu, setIsMoreMenu] = useState(false)
    
    const isMobile = useIsMobile(LG_BREAKPOINT)
    const isImpersonated = useSelector(selectIsImpersonated)

    const { data: applicationPackage } = settings.GetApplicationSettings.useQuery({
        select: (data) => data.applicationPackage,
    })

    const navData = navdata().props.children

    // items to move into "More" dropdown on desktop (add more IDs as needed)
    const splitItemIds = ['reports', 'intermediaryDiary', 'evidenceDiary']

    const handleMenuItems = (navItems) => {
        const isStandardAppPackage = applicationPackage?.name === 'Standard'
        const desktopItems = []
        const subMenu = {
            id: 'more',
            icon: 'ri-more-fill',
            isOpen: isMoreMenu,
            subItems: [],
            click: () => setIsMoreMenu(!isMoreMenu),
        }

        navItems.forEach((data) => {
            // no need for submenu in Basic/Start app packages, only for Standard
            splitItemIds.includes(data.id) && isStandardAppPackage ? subMenu.subItems.push(data) : desktopItems.push(data)
        })

        if (subMenu.subItems.length) {
            desktopItems.push(subMenu)
        }

        return { desktopItems, mobileItems: navItems }
    }

    const menuItems = handleMenuItems(navData)

    const handleLinkClick = () => {
        // close mobile dropdown
        document.body.classList.remove('menu')
        // clear selected table rows when navigating
        dispatch(resetTableCheckbox(true))
    }

    const renderNavigation = (item) => {
        return item.subItems ? renderSubMenu(item) : renderMainLinks(item)
    }

    const renderMenu = (items) => {
        return (
            <ul className="navbar-nav">
                {items.map((item, key) => (
                    <React.Fragment key={key}>{renderNavigation(item)}</React.Fragment>
                ))}
            </ul>
        )
    }

    const renderMainLinks = (item) => {
        return (
            <li className="nav-item">
                <AppTopSwitcher link={item.link} feature="Navigation" permission="Navigation">
                    {({ featureLinkAllowed, permissionLinkAllowed }) => {
                        const isLinkAvailable = featureLinkAllowed && permissionLinkAllowed

                        const linkTo = () => {
                            if (!item.link) return '/#'
                            if (item.historyState) {
                                return {
                                    pathname: item.link,
                                    state: item.historyState,
                                }
                            }
                            return item.link
                        }

                        return (
                            <NavLink
                                className={`nav-link menu-link ${!isLinkAvailable ? 'd-none' : ''}`}
                                activeClassName={isImpersonated ? 'active active-impersonated' : 'active'}
                                to={linkTo()}
                                onClick={handleLinkClick}
                            >
                                <i className={item.icon}></i> <span>{item.label}</span>
                            </NavLink>
                        )
                    }}
                </AppTopSwitcher>
            </li>
        )
    }

    // 3 dots menu
    const renderSubMenu = (item) => {
        return (
            <li className="nav-item">
                <AppPermissionsSwitcher subItems={item.subItems} permission="SubMenu">
                    {({ updatedSubItems }) => {
                        const hideSubMenu = updatedSubItems.every((item) => !item.isLinkAvailable)

                        return (
                            <>
                                {!hideSubMenu ? (
                                    <Button onClick={item.click} className="nav-link menu-link" color="link">
                                        <i className={item.icon}></i> <span>{item.label}</span>
                                    </Button>
                                ) : null}

                                <Collapse className={'menu-dropdown'} isOpen={item.isOpen} id="sidebarApps">
                                    <ul className="nav flex-column">
                                        {updatedSubItems?.map((subItem, key) => (
                                            <React.Fragment key={key}>
                                                <li className="nav-item">
                                                    <NavLink
                                                        to={subItem.link ? subItem.link : '/#'}
                                                        className={subItem.className}
                                                        activeClassName="active"
                                                        style={{ color: 'black' }}
                                                        state={subItem.historyState}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {subItem.label}
                                                    </NavLink>
                                                </li>
                                            </React.Fragment>
                                        ))}
                                    </ul>
                                </Collapse>
                            </>
                        )
                    }}
                </AppPermissionsSwitcher>
            </li>
        )
    }

    return (
        <>
            {/* mobile menu - all items as flat list */}
            {isMobile && renderMenu(menuItems.mobileItems)}

            {/* desktop menu - items with "More" submenu */}
            {!isMobile && renderMenu(menuItems.desktopItems)}
        </>
    )
}

HorizontalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
}

export default withRouter(HorizontalLayout)
